(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evergreen-launch-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('[data-gp-evergreen-form]');
    if (!forms.length) return;

    function setStatus(form, message, state) {
      var status = form.querySelector('[data-gp-evergreen-status]');
      if (!status) return;
      status.textContent = message;
      if (state) {
        status.setAttribute('data-state', state);
      } else {
        status.removeAttribute('data-state');
      }
    }

    function setBusy(form, isBusy) {
      var button = form.querySelector('button[type="submit"]');
      if (!button) return;
      var defaultLabel = button.getAttribute('data-default-label') || 'Notify me';
      var successLabel = button.getAttribute('data-success-label') || 'You are on the list';
      button.disabled = isBusy;
      button.textContent = isBusy ? 'Registering...' : button.getAttribute('data-complete') === 'true' ? successLabel : defaultLabel;
    }

    function buildPayload(email) {
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Evergreen launch page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    evergreen_interest: true
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'VEgmiC'
              }
            }
          }
        }
      };
    }

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var emailInput = form.querySelector('input[name="email"]');
        if (!emailInput || !emailInput.checkValidity()) {
          if (emailInput) emailInput.reportValidity();
          return;
        }

        var email = emailInput.value.trim();
        var button = form.querySelector('button[type="submit"]');
        if (button) button.removeAttribute('data-complete');
        setBusy(form, true);
        setStatus(form, '', '');

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VrhhP3', {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2026-04-15'
          },
          body: JSON.stringify(buildPayload(email))
        }).then(function (response) {
          if (!response.ok) throw new Error('Klaviyo subscription failed');
          if (button) button.setAttribute('data-complete', 'true');
          setStatus(form, 'Thanks. You are on the Evergreen interest list.', 'success');
          form.reset();
        }).catch(function () {
          setStatus(form, 'Something went wrong. Please try again in a moment.', 'error');
        }).finally(function () {
          setBusy(form, false);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
